import React, {Fragment} from "react";
import {Avatar} from "primereact/avatar";
import {generateHSL, getLettereAvatar} from "../../../utility/avatar";
import {getTimestampFormattato} from "../../../utility/common";

export default function CommentoView({
                                         usr,
                                         commento,
                                         isUsrLoggato,
                                         translate,
                                         deleteCallback,
                                         onClickDettaglio,
                                     }) {

    return (
        <div style={{paddingBottom: "2rem"}} className={isUsrLoggato() ? 'text-end' : 'text-start'}>
            {
                !isUsrLoggato() &&
                <div className={"pb-2"} style={{
                    display: "inline-flex"
                }}>
                    <Avatar
                        label={getLettereAvatar(usr)}
                        shape="circle"
                        style={{
                            color: "#ffffff",
                            backgroundColor: generateHSL(getLettereAvatar(usr)),
                        }}
                    />
                    <h5 className={"ps-3"}>{commento.usr_ins}</h5>
                </div>
            }
            <div className={isUsrLoggato() ? 'sost-container-commento--loggato' : 'text-start'}>
                <div className={"sost-commento " + (isUsrLoggato() && "sost-commento--usr-loggato")}>
                    <span>
                        {commento.testo}
                    </span>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-md-12"}>
                    <p className={"sost-commento--footer " + (isUsrLoggato() && "sost-commento--footer-loggato")}>
                        <i>{getTimestampFormattato(commento.data_ins)}</i>
                        {
                            commento.usr_ultima_mod && (
                                <Fragment>
                                    &nbsp;(<span className={"fas fa-pen"}></span>&nbsp;
                                    <i>{commento.usr_ultima_mod} - {getTimestampFormattato(commento.data_ultima_mod)}</i>)
                                </Fragment>
                            )
                        }
                        <span
                            style={{
                                fontSize: "16px"
                            }}
                            className={"fas fa-file-alt ns-mouse-pointer pe-3 ps-3"}
                            data-toggle="tooltip" title={translate("Dettaglio")}
                            onClick={onClickDettaglio}
                        />
                        {
                            commento.modificabile && (
                                <span
                                    style={{
                                        fontSize: "16px"
                                    }}
                                    className={"fas fa-trash ns-mouse-pointer"}
                                    data-toggle="tooltip" title={translate("Elimina")}
                                    onClick={() => {
                                        deleteCallback(commento)
                                    }}
                                />
                            )
                        }
                    </p>
                </div>
            </div>

        </div>
    );
}
